import React, { useRef } from 'react';
import './CardJugador.css';

const CLUBS = {
  AAJ: { p: '#e30613', s: '#ffffff', shirt: 'diagonal' },
  ALD: { p: '#006f3c', s: '#ffd700', shirt: 'mitad' },
  ATU: { p: '#ffffff', s: '#000000', shirt: 'rayas_v' },
  BAN: { p: '#006f3c', s: '#ffffff', shirt: 'rayas_v' },
  BAR: { p: '#e30613', s: '#000000', shirt: 'mitad' },
  BEL: { p: '#0057a8', s: '#ffffff', shirt: 'rayas_v' },
  BOC: { p: '#003087', s: '#ffd700', shirt: 'franja_h' },
  CCO: { p: '#e30613', s: '#000000', shirt: 'diagonal' },
  DYJ: { p: '#ffd700', s: '#000000', shirt: 'rayas_v' },
  ELP: { p: '#e30613', s: '#ffffff', shirt: 'rayas_v' },
  ERC: { p: '#e30613', s: '#ffffff', shirt: 'rayas_v' },
  GEM: { p: '#0057a8', s: '#ffffff', shirt: 'rayas_v' },
  GLP: { p: '#0057a8', s: '#ffffff', shirt: 'rayas_v' },
  HUR: { p: '#ffffff', s: '#ffffff', shirt: 'solida' },
  IND: { p: '#e30613', s: '#0057a8', shirt: 'solida' },
  INS: { p: '#e30613', s: '#ffd700', shirt: 'franja_h' },
  IRV: { p: '#0057a8', s: '#ffffff', shirt: 'mitad' },
  LAN: { p: '#6b1a2b', s: '#6b1a2b', shirt: 'solida' },
  NOB: { p: '#e30613', s: '#000000', shirt: 'mitad' },
  PLA: { p: '#000000', s: '#ffd700', shirt: 'rayas_v' },
  RAC: { p: '#87ceeb', s: '#ffffff', shirt: 'rayas_v' },
  RIE: { p: '#e30613', s: '#000000', shirt: 'diagonal' },
  RIV: { p: '#e30613', s: '#ffffff', shirt: 'banda' },
  ROS: { p: '#003087', s: '#ffd700', shirt: 'rayas_v' },
  SAR: { p: '#006f3c', s: '#ffffff', shirt: 'solida' },
  SLO: { p: '#003087', s: '#e30613', shirt: 'rayas_v' },
  TAL: { p: '#000000', s: '#0057a8', shirt: 'diagonal' },
  TIG: { p: '#e30613', s: '#0057a8', shirt: 'rayas_v' },
  UNI: { p: '#e30613', s: '#ffffff', shirt: 'solida' },
  VEL: { p: '#0057a8', s: '#ffffff', shirt: 'solida' },
  ARS: { p: '#6b1a2b', s: '#6b1a2b', sl: '#87ceeb', sr: '#87ceeb', shirt: 'cuello_manga' },
};

const SELECCIONES = {
  'Argentina':      { p: '#74acdf', s: '#ffffff', shirt: 'rayas_v' },
  'Brasil': { p: '#f0d000', s: '#00501f', sl: '#006828', sr: '#006125', shirt: 'cuello_manga' },
  'Francia': { p: '#002395', s: '#ffffff', sl: '#002395', sr: '#002395', shirt: 'cuello_manga' },
  'España':         { p: '#ca1414', s: '#000e3d', sl: '#c9ab01', sr: '#c9ab01', shirt: 'cuello_manga' },
  'Alemania': { p: '#ffffff', s: '#d6c801', sl: '#dd0000', sr: '#0c0c0c', shirt: 'v_pecho' },
  'Inglaterra':     { p: '#ffffff',s: '#ffffff', sl: '#0f0050', sr: '#0f0050', shirt: 'cuello_manga' },
  'Portugal':       { p: '#8a0000',s: '#016109', sl: '#016109', sr: '#016109', shirt: 'cuello_manga' },
  'Países Bajos':   { p: '#ff6600', s: '#ffffff', shirt: 'solida' },
  'Bélgica':       { p: '#b10101',s: '#b10101', sl: '#e9c706', sr: '#000000', shirt: 'cuello_manga' },
  'Croacia': { p: '#e31920', s: '#ffffff', shirt: 'cuadros' },
  'Uruguay':        { p: '#75aadb', s: '#ffffff', shirt: 'solida' },
  'Colombia':       { p: '#f0d000', s: '#f0d000', sl: '#0063b4', sr: '#0063b4', shirt: 'cuello_manga' },
  'México':         { p: '#006847', s: '#ffffff', sl: '#e60b0b', sr: '#e60b0b', shirt: 'cuello_manga' },
   'USA': { p: '#ffffff', s: '#bf0a30', sl: '#002868', sr: '#002868', shirt: 'rayas_h' }, 
   'Estados Unidos': { p: '#ffffff', s: '#bf0a30', sl: '#002868', sr: '#002868', shirt: 'rayas_h' }, 
   'Japón': { p: '#003087', s: '#ffffff', sl: '#cf081f', sr: '#cf081f', shirt: 'ori' },
  'Corea del Sur':  { p: '#be2129', s: '#ffffff', shirt: 'solida' },
  'Marruecos':      { p: '#c80404',s: '#c80404', sl: '#016109', sr: '#016109', shirt: 'cuello_manga' },
  'Senegal':       { p: '#ffffff',s: '#016109', sl: '#016109', sr: '#016109', shirt: 'cuello_manga' },
  'Irán':           { p: '#ffffff', s: '#ffffff', shirt: 'solida' },
  'Australia':      { p: '#f0a800', s: '#006828', sl: '#f0a800', sr: '#f0a800', shirt: 'cuello_manga' },
  'Suiza':          { p: '#c80404',s: '#c80404', sl: '#fdfdfd', sr: '#e9e9e9', shirt: 'cuello_manga' },
  'Austria':        { p: '#c80404',s: '#060000', sl: '#060000', sr: '#060000', shirt: 'cuello_manga' },
  'Turquía':        { p: '#880000',s: '#f40000', sl: '#f40000', sr: '#f40000', shirt: 'cuello_manga' },
  'Escocia':        { p: '#05004f', s: '#030032', sl: '#ffffff', sr: '#ffffff', shirt: 'cuello_manga' },
  'Canadá':         { p: '#ff0000', s: '#a70000', shirt: 'mitad' },
  'Arabia Saudita': { p: '#006828', s: '#ffffff', sl: '#006828', sr: '#006828', shirt: 'cuello_manga' },
  'Panamá':          { p: '#ca1414', s: '#01269e', sl: '#ca1414', sr: '#ca1414', shirt: 'cuello_manga' },
  'Egipto':         { p: '#c80404',s: '#c80404', sl: '#060000', sr: '#060000', shirt: 'cuello_manga' },
  'Qatar':          { p: '#621212', s: '#621212', sl: '#ffffff', sr: '#ffffff', shirt: 'cuello_manga' },
  'Irak':            { p: '#ffffff',s: '#000000', sl: '#010006', sr: '#010007', shirt: 'cuello_manga' },
  'Uzbekistán':     { p: '#2421f9', s: '#0b08b0', shirt: 'cuadros' },
  'Nueva Zelanda':  { p: '#000000', s: '#ffffff', shirt: 'solida' },
  'Paraguay':       { p: '#d52b1e', s: '#ffffff', shirt: 'rayas_v' },
  'Suecia':         { p: '#f0d000', s: '#2421f9', sl: '#2421f9', sr: '#2421f9', shirt: 'cuello_manga' },
  "Costa de Marfil":   { p: '#d97000', s: '#d97000', sl: '#005411', sr: '#005411', shirt: 'cuello_manga' },
  'Ecuador':         { p: '#f0d000', s: '#f0d000', sl: '#010033', sr: '#010033', shirt: 'cuello_manga' },
  'Bosnia':  { p: '#0b0087', s: '#0b0087', sl: '#ffffff', sr: '#eddd00', shirt: 'cuello_manga' },
  'República Checa':  { p: '#980000', s: '#980000', sl: '#ffffff', sr: '#0b0087', shirt: 'cuello_manga' },
  'Curazao':        { p: '#0b0087', s: '#eddd00', sl: '#0b0087', sr: '#0b0087', shirt: 'cuello_manga' },
  'Cabo Verde':      { p: '#1200d5', s: '#ed0000', sl: '#060048', sr: '#060048', shirt: 'cuello_manga' },
  'Sudáfrica':      { p: '#005838', s: '#ffb81c', shirt: 'mitad' },
  'RD Congo':        { p: '#02c4ff', s: '#ed0000', sl: '#ed0000', sr: '#ed0000', shirt: 'cuello_manga' },
  'Ghana': { p: '#ffffff', s: '#000000', sl: '#000000', sr: '#000000', shirt: 'geo' },
  'Argelia':        { p: '#f7f4cf',s: '#f5f1b5', sl: '#2c8300', sr: '#e10000', shirt: 'cuello_manga' },
  'Jordania':        { p: '#ffffff',s: '#ffffff', sl: '#b60000', sr: '#b60000', shirt: 'cuello_manga' },
  'Haití':          { p: '#1200d5', s: '#1200d5', sl: '#fcfcfc', sr: '#ff0000', shirt: 'cuello_manga' },
  'Túnez':          { p: '#ffffff',s: '#ce0000', sl: '#aaaaaa', sr: '#aaaaaa', shirt: 'cuello_manga' },
  'Haiti':          { p: '#00209f', s: '#d21034', shirt: 'mitad' },
  'Scotland':       { p: '#003580', s: '#ffffff', shirt: 'solida' },
  'Túnez':          { p: '#ffffff',s: '#ce0000', sl: '#aaaaaa', sr: '#aaaaaa', shirt: 'cuello_manga' },
  'IR Iran':        { p: '#239f40', s: '#ffffff', shirt: 'franja_h' },
  'New Zealand':    { p: '#000000', s: '#ffffff', shirt: 'solida' },
  'Saudi Arabia':   { p: '#006c35', s: '#ffffff', shirt: 'solida' },
  'Korea Republic': { p: '#c9151e', s: '#ffffff', shirt: 'solida' },
  'South Africa':   { p: '#007a4d', s: '#ffb81c', shirt: 'diagonal' },
  'Noruega': { p: '#ef2b2d', s: '#001a44', shirt: 'cruz_nordica' },
  'Bosnia y Herzegovina': { p: '#0b0087', s: '#0b0087', sl: '#ffffff', sr: '#eddd00', shirt: 'cuello_manga' },
'Chequia':    { p: '#980000', s: '#980000', sl: '#ffffff', sr: '#0b0087', shirt: 'cuello_manga' },
'Costa de Marfil': { p: '#d97000', s: '#d97000', sl: '#005411', sr: '#005411', shirt: 'cuello_manga' },
'Curazao':    { p: '#0b0087', s: '#eddd00', sl: '#0b0087', sr: '#0b0087', shirt: 'cuello_manga' },
'DR Congo':   { p: '#02c4ff', s: '#ed0000', sl: '#ed0000', sr: '#ed0000', shirt: 'cuello_manga' },
'Iraq':       { p: '#ffffff', s: '#000000', sl: '#010006', sr: '#010007', shirt: 'cuello_manga' },
};

const DEFAULT = { p: '#00f2ff', s: '#ffffff', shirt: 'solida' };

const STATUS_LABEL = {
  titular:   'TITULAR',
  duda:      'EN DUDA',
  lesionado: 'LESIONADO',
  no_juega:  'NO JUEGA',
};
const STATUS_BORDER = {
  titular:   '#22c55e',
  duda:      '#f97316',
  lesionado: '#ef4444',
  no_juega:  '#ef4444',
};

let _c = 0;

const ShirtSVG = ({ p, s, sl, sr, shirt, dorsal }) => {
  // sl = color manga izquierda (sleeve left), sr = color manga derecha (sleeve right)
  // si no se pasan, usan s (color secundario) — retrocompatible con todos los estilos existentes
  const mangaIzq = sl || s;
  const mangaDer = sr || s;
  const id = useRef(`sh${++_c}`).current;
  const W = 36, H = 32;
  const pts = `${W*.25},0 ${W*.75},0 ${W},${H*.22} ${W*.88},${H*.44} ${W*.75},${H*.32} ${W*.75},${H} ${W*.25},${H} ${W*.25},${H*.32} ${W*.12},${H*.44} 0,${H*.22}`;

  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={{display:'block', filter:'drop-shadow(0 2px 4px rgba(0,0,0,0.7))'}}>
      <defs><clipPath id={id}><polygon points={pts}/></clipPath></defs>
      <g clipPath={`url(#${id})`}>
        <rect width={W} height={H} fill={p}/>
        {shirt==='banda'        && <><rect width={W} height={H} fill={s}/><polygon points={`${W*.3},0 ${W*.66},0 ${W},${H} ${W*.64},${H}`} fill={p}/></>}
        {shirt==='franja_h'     && <rect x={0} y={H*.36} width={W} height={H*.28} fill={s}/>}
        {shirt==='rayas_v'      && [0,1,2,3,4,5].map(i=><rect key={i} x={i*W/6} y={0} width={W/12} height={H} fill={s} opacity=".9"/>)}
        {shirt==='diagonal'     && <polygon points={`0,${H*.4} 0,${H} ${W},0 ${W*.6},0`} fill={s}/>}
        {shirt==='mitad'        && <rect x={W/2} y={0} width={W/2} height={H} fill={s}/>}
        {shirt==='cuello_manga' && <>
        
          {/* Manga izquierda — color independiente mangaIzq */}
          <polygon points={`0,${H*.22} ${W*.12},${H*.44} ${W*.25},${H*.32} ${W*.25},${H*.20} ${W*.12},${H*.32}`} fill={mangaIzq}/>
          {/* Manga derecha — color independiente mangaDer */}
          <polygon points={`${W},${H*.22} ${W*.88},${H*.44} ${W*.75},${H*.32} ${W*.75},${H*.20} ${W*.88},${H*.32}`} fill={mangaDer}/>
          {/* Cuello — franja fina superior central, usa s */}
          <rect x={W*.3} y={0} width={W*.4} height={H*.13} fill={s}/>
        </>}
        {shirt==='v_pecho' && <>
  <polygon points={`${W*.1},0 ${W*.9},0 ${W*.55},${H*.5} ${W*.45},${H*.5}`} fill={s}/>
  {sl && <polygon points={`${W*.18},0 ${W*.82},0 ${W*.55},${H*.42} ${W*.45},${H*.42}`} fill={sl}/>}
  {sr && <polygon points={`${W*.26},0 ${W*.74},0 ${W*.55},${H*.34} ${W*.45},${H*.34}`} fill={sr}/>}
</>}
{shirt==='cuadros' && <>
  <defs>
    <pattern id={`cq${id}`} x="0" y="0" width={W/6} height={H/6} patternUnits="userSpaceOnUse">
      <rect width={W/12} height={H/12} fill={s}/>
      <rect x={W/12} y={H/12} width={W/12} height={H/12} fill={s}/>
    </pattern>
  </defs>
  <rect width={W} height={H} fill={`url(#cq${id})`}/>
</>}
{shirt==='rayas_h' && [0,1,2,3,4,5,6].map(i =>
  i % 2 === 1 ? <rect key={i} x={0} y={i*H/7} width={W} height={H/7} fill={s}/> : null
)}
{shirt==='geo' && <>
  <line x1={W*.5} y1={H*.4} x2={0}    y2={0}    stroke={s} strokeWidth="0.8"/>
  <line x1={W*.5} y1={H*.4} x2={W}    y2={0}    stroke={s} strokeWidth="0.8"/>
  <line x1={W*.5} y1={H*.4} x2={0}    y2={H}    stroke={s} strokeWidth="0.8"/>
  <line x1={W*.5} y1={H*.4} x2={W}    y2={H}    stroke={s} strokeWidth="0.8"/>
  <line x1={W*.5} y1={H*.4} x2={W*.5} y2={0}    stroke={s} strokeWidth="0.8"/>
  <line x1={W*.5} y1={H*.4} x2={0}    y2={H*.5} stroke={s} strokeWidth="0.8"/>
  <line x1={W*.5} y1={H*.4} x2={W}    y2={H*.5} stroke={s} strokeWidth="0.8"/>
</>}
{shirt==='cruz_nordica' && <>
  {/* Cruz blanca (borde) */}
  <rect x={W*.33} y={0} width={W*.18} height={H} fill="#ffffff"/>
  <rect x={0} y={H*.36} width={W} height={H*.28} fill="#ffffff"/>
  {/* Cruz azul (encima) */}
  <rect x={W*.38} y={0} width={W*.09} height={H} fill={s}/>
  <rect x={0} y={H*.41} width={W} height={H*.18} fill={s}/>
</>}
{shirt==='ori' && <>
  {[0,1,2,3,4,5,6,7,8,9,10,11].map(i => {
    const ang = (i / 12) * Math.PI * 2;
    return <line key={i}
      x1={W*.5} y1={H*.3}
      x2={W*.5 + Math.cos(ang)*W} y2={H*.3 + Math.sin(ang)*H}
      stroke="#ffffff" strokeWidth="0.6" opacity="0.25"/>
  })}
</>}
        {dorsal && (
          <text
            x={W/2} y={H*0.55}
            textAnchor="middle" dominantBaseline="central"
            fontSize={dorsal.length > 1 ? "12" : "14"}
            fontWeight="900"
            fontFamily="Arial Black, monospace"
            fill="#000000"
            stroke="#ffffff"
            strokeWidth="1.5"
            paintOrder="stroke"
          >{dorsal}</text>
        )}
      </g>
      <polygon points={pts} fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="0.8"/>
    </svg>
  );
};

const CardJugador = ({ jugador, posicion, isMini, esCapitan, puntos }) => {
  if (!jugador) {
    return (
      <div className={`card-jugador empty ${isMini?'mini':''}`}>
        <span className="card-pos-empty">{posicion}</span>
      </div>
    );
  }

  const sigla   = jugador.club?.sigla || '';
  const esMundial = jugador.contexto === 'mundial';
  const club    = esMundial
    ? (SELECCIONES[jugador.seleccion] || DEFAULT)
    : (CLUBS[sigla] || DEFAULT);
  const displaySigla = esMundial
    ? (jugador.seleccion?.slice(0, 3).toUpperCase() || 'SEL')
    : (sigla || 'S/C');
  const dorsal  = jugador.dorsal ? String(jugador.dorsal) : '';
  const light   = ['#ffffff','#ffd700','#87ceeb'].includes(club.p);
  const badgeColor = light ? '#000' : '#fff';
  const borderColor = STATUS_BORDER[jugador.status] || '#22c55e';
  const statusLabel = STATUS_LABEL[jugador.status] || 'TITULAR';

  return (
    <div
      className={`card-jugador ${jugador.status||'titular'} ${isMini?'mini':''}`}
      style={{ '--cp': club.p, borderColor, boxShadow: `0 0 10px ${borderColor}ee, 0 0 24px ${borderColor}88, 0 0 44px ${borderColor}33` }}
    >
      {esCapitan && (
        <div className="card-capitan-badge">C</div>
      )}
      {puntos != null && (
        <div className="card-puntos-badge">{puntos}</div>
      )}

      <div className="card-accent" style={{ background: `linear-gradient(90deg, transparent, ${borderColor}, transparent)` }}/>

      <div className="card-shirt">
        <ShirtSVG p={club.p} s={club.s} sl={club.sl} sr={club.sr} shirt={club.shirt} dorsal={dorsal}/>
      </div>

      <span className="card-sigla">{displaySigla}</span>

    <span className="card-nombre">
  {jugador.apellido
    ? `${jugador.apellido}${jugador.nombre ? ` ${jugador.nombre.charAt(0)}.` : ''}`
    : jugador.nombre || '?'}
</span>

      <span className="card-badge" style={{background: club.p, color: badgeColor}}>
        {posicion}
      </span>

      <span className="card-precio">${(jugador.precio/1000000).toFixed(1)}M</span>

      <div className="card-status-label">{statusLabel}</div>

      <div className="card-footer">
        {jugador.nacionalidad?.slice(0,3).toUpperCase()} | {jugador.pie_habil==='Izquierdo'?'IZQ':'DER'}
      </div>
    </div>
  );
};

export { CLUBS, SELECCIONES, ShirtSVG };
export default CardJugador;